import { Spin } from "antd";
import "./index.css";

export default function Loading() {
  return (
    <div className="loading-page">
      <Spin size="large" />
    </div>
  );
}
